<div class="p-inputgroup">
  <p-dropdown
    #dropdown
    [(ngModel)]="trailerId"
    [options]="trailers"
    optionValue="id"
    [disabled]="disabled"
    [readonly]="readonly"
    [filter]="true"
    filterBy="trailerNumber"
    (onFocus)="OnFocus($event)"
    (onBlur)="OnBlur()"
    (onShow)="OnShow()"
    (onHide)="OnHide()"
    (onChange)="OnChange()"
    [name]="name"
    placeholder="Select Trailer"
    [tabindex]="tabindex"
    [resetFilterOnHide]="true"
    [autofocusFilter]="true"
    appendTo="body">
    <ng-template pTemplate="selectedItem" let-trailer>
      <div>
        {{trailer.trailerNumber}}
        <span class="carriercodetext">{{trailer.carrier.carrierCode}}</span>
        <span class="text-deemphasized"> ({{GetStatusString(trailer.trailerStatus)}})</span>
      </div>
    </ng-template>
    <ng-template pTemplate="item" let-trailer>
      <div>
        {{trailer.trailerNumber}}
        <span class="carriercodetext">{{trailer.carrier.carrierCode}}</span>
        <span class="text-deemphasized"> ({{GetStatusString(trailer.trailerStatus)}})</span>
      </div>
    </ng-template>
  </p-dropdown>
  <button pButton type="button"
    #addButton
    [tabindex]="addButtonTabIndex"
    [disabled]="disabled"
    icon="pi pi-plus"
    label="Add"
    (click)="showAddDialog = true">
  </button>
</div>

<p-dialog [modal]="true"
  [(visible)]="showAddDialog"
  header="Add New Trailer"
  appendTo="body">

  <div [formGroup]="addForm">
    <div class="p-grid">
      <div class="form-group p-col-6">
        <label for="trailerNumber" class="required">Trailer Number</label>
        <input id="trailerNumber" type="text" pInputText formControlName="trailerNumber" />
        <error-block
          [field]="addForm.controls.trailerNumber"
          [messages]="{
            required: 'Trailer Number is required',
            maxLength: 'Trailer Number must be less than 50 characters'
          }"></error-block>
      </div>
      <div class="form-group p-col-6">
        <label class="required" for="carrier">Carrier</label>
        <div *ngIf="!canChooseCarrier" class="form-control-static">
          {{(_carrier | async)?.carrierName}}
        </div>
        <app-carrier-select
          *ngIf="canChooseCarrier"
          formControlName="carrierId">
        </app-carrier-select>
        <error-block
          [field]="addForm.controls.carrierId"
          [messages]="{
            required: 'Carrier is required.'
          }"></error-block>
      </div>
    </div>
    <div class="p-grid">
      <div class="p-col-6 form-group">
        <label class="required" for="subinventoryId">Operation</label>
        <p-dropdown
          *ngIf="canChooseSubinventory"
          [editable]="false"
          [options]="subinventorySelects | async"
          formControlName="subinventoryId"
          inputId="subinventoryId"
          placeholder="-- Select Operation --">
        </p-dropdown>
        <div *ngIf="!canChooseSubinventory" class="form-control-static">
          {{subinventoryName | async}}
        </div>
        <error-block
          [field]="addForm.controls.subinventoryId"
          [messages]="{
            required: 'Operation is required.'
          }">
        </error-block>
      </div>
    </div>
  </div>
  <p-footer>
    <button pButton type="button"
      label="Cancel"
      class="p-button-secondary"
      (click)="showAddDialog = false"></button>
    <button pButton type="button"
      label="Save"
      class="p-button-success"
      (click)="SaveNewTrailer()"></button>
  </p-footer>
</p-dialog>
